import { useEffect, useRef } from "react";
import { useLogout } from "@/api/hooks/auth";

const EVENTS = ["pointerdown", "keydown", "scroll", "visibilitychange"] as const;

/** Signs the user out after `minutes` without pointer, key, scroll or visibility activity. */
export function useIdleLogout(minutes = 30): void {
  const logout = useLogout();
  const mutateRef = useRef(logout.mutate);
  mutateRef.current = logout.mutate;

  useEffect(() => {
    const ms = minutes * 60 * 1000;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const arm = () => {
      if (timer !== undefined) clearTimeout(timer);
      timer = setTimeout(() => mutateRef.current(), ms);
    };
    arm();
    for (const e of EVENTS) window.addEventListener(e, arm, { passive: true });
    return () => {
      if (timer !== undefined) clearTimeout(timer);
      for (const e of EVENTS) window.removeEventListener(e, arm);
    };
  }, [minutes]);
}
